// 加载腾讯地图
export function loadTMAP() {
  const key = process.env.VUE_APP_TMAP_KEY
  const tmapUrl = 'https://map.qq.com/api/gljs?v=1.exp&libraries=service&key=' + key + '&callback=onTMapCallback'
  const onTMapCallback = () => {
    return window.TMap
  }

  function createScript(url, cb) {
    return new Promise((resolve, reject) => {
      const node = document.createElement('script')
      node.setAttribute('type', 'text/javascript')
      node.setAttribute('src', url)
      document.body.append(node)
      node.onload = () => {
        const ret = cb()
        resolve(ret)
      }
    })
  }
  return Promise.resolve(createScript(tmapUrl, onTMapCallback))
}

/**
 *
 * @returns 是否是移动端
 */
export const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
